import { Component, OnInit } from '@angular/core';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-HelpList',
  templateUrl: './HelpList.component.html',
  styleUrls: ['./HelpList.component.scss']
})
export class HelpListComponent implements OnInit {

  Token: String = ""
  Filter_MenuType: String = "0"
  Data_List_Menu: Array<Nav_Interface> = []

  constructor(
    private Nav_Service: NavService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');


    this.Nav_Service.CheckValidPage(this.Token, 1128).subscribe(
      data => {
        this.Read_Data_Menu()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }

  OnChangeMeneType(){
    this.Read_Data_Menu()
  }

  Read_Data_Menu() {
    this.Nav_Service.GetUser(this.Token, 0, this.Filter_MenuType=="1").subscribe(
      data => {
        this.Data_List_Menu = data
        this.Data_List_Menu = this.FilterNav(0)
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  FilterNav(id: Number): Array<Nav_Interface> {
    var tempList: Array<Nav_Interface> = []
    for (let item of this.Data_List_Menu) {
      if (item.parent == id) {
        var temp: Nav_Interface = Empty_Nav_Interface()
        temp.id = item.id
        temp.icon = item.icon
        temp.link = item.link
        temp.parent = item.parent
        temp.title = item.title
        temp.child = this.FilterNav(item.id)

        tempList.push(temp)
      }

    }
    return tempList


  }

  Select_Record_Nav:Nav_Interface=Empty_Nav_Interface()
  Switcher_View:string='Table'

  set_Nav(item:Nav_Interface)
  {
    this.Select_Record_Nav=item
    this.Switcher_View='Form'
  }

  set_Form(item:any)
  {
    this.Switcher_View='Table'
  }

}
